import React, { useState, useEffect, useContext } from 'react';
import { StyledNavBar } from './NavBar.styled';
import {
  MapModal,
  LogoutModal,
  UploadModal,
  BroadsiderInfo,
  PlainButton,
  SelectableButton,
  AppMenuModal,
  BroadsiderSelectorModal,
  AssetModal,
  QrCodePopup,
  ErrorPopup,
  LoginModal,
  DesktopOnlyModal,
  BasejumpLogo,
  VideoModal,
  TransferModal,
  MintCompleteModal
} from '../../components';
import { useWeb3Modal } from '@web3modal/wagmi/react'
import { AppContext } from '../../providers/AppContext';
import { composeShortAddress, openUrl } from '../../utils';
import {
  useNavigate,
  useLocation
} from "react-router-dom";
import { useAccountEffect, useDisconnect } from 'wagmi';
import { theme } from '../../theme';
import useIsMobile from '../../hooks/useIsMobile';
import { MintModal } from '../MintActionFigures';
import { useTokenAuth } from '../../hooks';

const NO_AVATAR_IMG_SRC = '/assets/no_avatar.png';

const AccountSection = ({onClick, address}) => {
  return (
    <div className='nav-account-info'>
      <div className='nav-account-info-address'>{address}</div>
      <SelectableButton
        selected={false}
        isIconButton={true}
        backgroundOverwrite={theme.buttonBrightBlue}
        borderOverwrite='rgba(0, 0, 0, .16)'
        onClick={onClick}
        img='/assets/account_black.svg' />
    </div>
  );
};

const NavBar = ({ navOpen: open, setNavOpen: setOpen }) => {
  const isMobile = useIsMobile();
  const { open: openWalletPopup } = useWeb3Modal();
  const {
    transferAsset,
    setTransferAsset,
    selectedBroadsider,
    selectedAsset,
    setAccountAddress,
    setWalletAddress,
    setSelectedAsset,
    qrCodeData,
    setQrCodeData,
    setErrorData,
    errorData,
    showLogin,
    setShowLogin,
    accountAddress,
    moonpaySdk,
    showLogout,
    setShowLogout,
    setShowDesktopOnly,
    showDesktopOnly,
    setShowVideo,
    showVideo,
    showMintModal,
    setShowMintModal,
    mapSrc,
    setMapSrc,
    completeReceipt,
    setCompleteReceipt,
    showUpload,
    setShowUpload,
    showSelector,
    setShowSelector
  } = useContext(AppContext);
  const navigate = useNavigate();
  const myLocation = useLocation();
  useAccountEffect({
    onConnect({ address }) {
      setWalletAddress(address);
    },
    onDisconnect() {
      setWalletAddress(null);
    }
  });
  //const { disconnect } = useDisconnect();

  const { user } = useTokenAuth();

  useEffect(() => {
    if (user) {
      setAccountAddress(user.global_name);
      if (myLocation.pathname !== '/mint') {
          navigate('/app');
      }
    } else {
      setAccountAddress(null);
    }
  }, [user]);

  const showAvatarSelector = myLocation.pathname === '/app';
  const appMenuOptions = [
    { name: 'Home', onSelect: () => {
      navigate('/home');
      if (isMobile) {
        setShowMenu(false);
      }
    }, url: '/home'},
    // { name: 'About', onSelect: () => {
    //   navigate('/broadside');
    //   if (isMobile) {
    //     setShowMenu(false);
    //   }
    // }, url: '/broadside' },
    { name: 'App', onSelect: () => {
      navigate('/app');
      if (isMobile) {
        setShowMenu(false);
      }
    }, disabled: !accountAddress || isMobile, url: '/app' },
    // { name: 'Mint', onSelect: () => {
    //   navigate('/mint');      
    //   if (isMobile) {
    //     setShowMenu(false);
    //   }
    // }, url: '/mint' },
  ];

  const appMenuSubsections = [
    { name: 'Community', items: [
      { name: 'Twitter', onSelect: () => openUrl('https://twitter.com/basejumpxyz') },
      { name: 'Discord', onSelect: () => openUrl('http://discord.gg/basejump') }
    ] },
    { name: 'Legal', items: [
      { name: 'Terms of Service', onSelect: () => openUrl('/terms') },
      { name: 'Privacy Policy', onSelect: () => openUrl('/privacy') }
    ] }
  ];

  const onClickConnect = async () => {
    console.error({accountAddress});
    if (accountAddress) {
      if (showAvatarSelector) {
        setShowLogout(true);
      } else {
        navigate('/app');
      }
    } else {
      setShowLogin(true);
    }
  };

  const hideAllPopups = () => {
    setShowSelector(false);
    setShowMenu(false);
    setSelectedAsset(null);
    setTransferAsset(null);
    setQrCodeData(null);
    setErrorData(null);
    setShowLogin(false);
    setShowDesktopOnly(false);
    setShowLogout(false);
    setShowVideo(false);
    setShowMintModal(false);
    setCompleteReceipt(null);
    setShowUpload(false);
    setMapSrc(null);
  };

  const [showMenu, setShowMenu] = useState(false);
  const showBroadsiderInfo = accountAddress && selectedBroadsider && showAvatarSelector;
  const avatarImgSrc = selectedBroadsider ? selectedBroadsider.getAvatarImgSource() : NO_AVATAR_IMG_SRC;
  const addrLabel = accountAddress; //? composeShortAddress(accountAddress) : '';
  const selectedMenuIndex = appMenuOptions.findIndex((o) => o.url === myLocation.pathname) || 0;

  const onSelect = (index) => {
    const selectedOption = appMenuOptions[index];
    selectedOption.onSelect();
  };

  return (
    <StyledNavBar>
      <div className='nav-logo-bg'/>
      <div className='nav-logo' onClick={() => navigate('/home')}>
        {!showVideo && <BasejumpLogo />}
      </div>
      <div className='nav-info-and-controls'>
        {showBroadsiderInfo && <BroadsiderInfo broadsider={selectedBroadsider}/>}
        <div className='nav-controls'>
          {
            !isMobile && accountAddress && showAvatarSelector 
            ? (<SelectableButton selected={showSelector} img={avatarImgSrc} onClick={() => setShowSelector(!showSelector)}/>) 
            : <div />
          }
          {!isMobile && accountAddress && !showAvatarSelector ? (<AccountSection onClick={() => setShowLogout(true)} address={accountAddress}/>) : <div />}
	  {!isMobile &&<PlainButton onClick={onClickConnect}>{accountAddress ? (showAvatarSelector ? `${addrLabel}` : <div className='nav-open-app'><div>Open App</div><img src='/assets/controller.svg' /></div>) : 'Login'}</PlainButton>}
	  <SelectableButton selected={showMenu} isIconButton={true} onClick={() => setShowMenu(!showMenu)} imgHover={showMenu ? '/assets/close_hover.svg' : null} img={showMenu ? '/assets/close.svg' : '/assets/menu.svg'} />
          <div className='app-popup-background' style={{ visibility: !!mapSrc || !!completeReceipt || showMintModal || showVideo || showMenu || showSelector || !!selectedAsset || !!transferAsset || !!qrCodeData  || !!errorData || !!showLogin || !!showLogout || !!showUpload || !!showDesktopOnly ? 'visible' : 'hidden' }} onClick={hideAllPopups}>
            {transferAsset && <TransferModal asset={transferAsset}/>}
            {selectedAsset && <AssetModal asset={selectedAsset}/>}
            {qrCodeData && <QrCodePopup data={qrCodeData} />}
            {errorData && <ErrorPopup data={errorData} onClose={hideAllPopups}/>}
            {showLogin && <LoginModal/>}
            {showUpload && <UploadModal/>}
            {showDesktopOnly && <DesktopOnlyModal/>}
            {showVideo && <VideoModal/>}
            {showMintModal && <MintModal />}
            {completeReceipt && <MintCompleteModal receipt={completeReceipt}/>}
            {mapSrc && <MapModal src={mapSrc} />}
          </div>
        </div>
      </div>
      {showLogout && <LogoutModal/>}
      {showSelector && <BroadsiderSelectorModal />}
      {showMenu && <AppMenuModal options={appMenuOptions} subsections={appMenuSubsections} onSelect={onSelect} selectedIndex={selectedMenuIndex}/>}
    </StyledNavBar>
  )
};

export default NavBar;

